export enum InitializeTypeEnum{
    app_settings_not_loaded = "app_settings_not_loaded",
    default_organization_error = "default_organization_error",
    auth_data_not_present = "auth_data_not_present",
    navigation_error = "navigation_error",

    new_user_success = "new_user_success",
    success = "success",

    offline = "offline",
}